import { log } from '@/logger/logger.ts';
import { getAxiosInstance } from '@/services/axiosConfig';
import { httpReq } from '@/utils/api.utils';
import type { WorkspaceCustomFontDto } from '@/api/recipes';

const logger = log.getLogger('workspaces');
const axiosInstance = getAxiosInstance();

export const approveModelLegalTerms = async (modelIds: string[]) =>
  await httpReq<{ modelIds: string[] }, void>('/v1/workspaces/models/approve', { modelIds });

export const getWorkspace = async () => {
  try {
    const response = await axiosInstance.get('/v1/workspaces');
    return response.data;
  } catch (error) {
    logger.error('Error fetching workspace:', error);
    throw error;
  }
};

/** Matches GET /v1/workspaces/{workspaceId}/fonts (same DTO as recipe-scoped fonts). */
export const getWorkspaceFonts = async (workspaceId: string): Promise<WorkspaceCustomFontDto[]> => {
  try {
    const response = await axiosInstance.get<WorkspaceCustomFontDto[]>(`/v1/workspaces/${workspaceId}/fonts`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching workspace fonts:', error);
    throw error;
  }
};
